import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ImpersonationService } from '../services/impersonation.service';
import {
  IMPERSONATION_HEADER,
  SKIP_IMPERSONATION_HEADER,
  isImpersonationErrorDetail,
} from '@/app/features/impersonation/models/impersonation.models';

export const impersonationInterceptorFn: HttpInterceptorFn = (req, next) => {
  const impersonation = inject(ImpersonationService);
  const router = inject(Router);

  const skip = req.context.get(SKIP_IMPERSONATION_HEADER);
  const sessionId = impersonation.sessionId();

  if (sessionId && !skip) {
    req = req.clone({
      setHeaders: { [IMPERSONATION_HEADER]: sessionId },
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const detail = (error.error as { detail?: unknown })?.detail;

      const isImpersonationFailure =
        (error.status === 401 || error.status === 404) && isImpersonationErrorDetail(detail);

      if (isImpersonationFailure && impersonation.isActive()) {
        impersonation.clear();
        router.navigate(['/impersonation'], { queryParams: { expired: 1 } });
      }

      return throwError(() => error);
    }),
  );
};
